import { useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Helmet from "react-helmet";

import ConfirmSignInForm, {
  type ConfirmSignInFormData,
} from "@covertree/ui/forms/auth/ConfirmSignInForm";
import { useAuthContext } from "@covertree/auth";

import { Toast } from "@covertree/utils";

import { AUTH_ROUTES } from "../paths";

interface ConfirmSignInProps {
  title: string;
}

const ConfirmSignIn = ({ title }: ConfirmSignInProps) => {
  const { state } = useLocation();

  const challenge = state?.challenge;
  const username = state?.username;
  const password = state?.password;

  const { confirmSignIn, login } = useAuthContext();

  if (!username) {
    return <Navigate to={AUTH_ROUTES.LOGIN} />;
  }

  const submit = useCallback(
    async ({ code }: ConfirmSignInFormData) => {
      try {
        await confirmSignIn(code);
      } catch (e) {
        Toast.showError(e);
      }
    },
    [confirmSignIn]
  );

  const resendCode = useCallback(async () => {
    try {
      await login({ username, ...(password ? { password } : {}) });
      Toast.showSuccess("Code sent");
    } catch (e) {
      Toast.showError(e);
    }
  }, [login, username]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ConfirmSignInForm
        submit={submit}
        resendCode={
          challenge === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
            ? undefined
            : resendCode
        }
      />
    </>
  );
};

export default ConfirmSignIn;
